
import {
  homeRoute,
  loginRoute,
  userManagementRoute,
  clientAdministrationRoute,
  changePasswordRoute,
  editProfileRoute,
  categoryRoute,
  subscriptionRoute,
  privacypolicyRoute,
  orderRoute,
  DeliveryDetailsRoute,
  productTemplateRoute,
  salesOverviewRoute,
  invoiceRoute
} from './../../core/routing/route-names';
import {
  Component,
  ViewChild,
  OnInit,
  ElementRef,
  Renderer2,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { UserInfoDTO } from '../models/models.swagger.generated';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { ModalService } from '../shared/modal/modal.service';
import { NgClass, NgIf } from '@angular/common';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { VersionService } from '../services/version/version.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    NgIf,
    LanguageSelectorComponent,
    TranslateModule,
    MenuModule,
    ButtonModule,
    RouterLink,
    RouterLinkActive,
  ],
})
export class NavigationComponent implements OnInit, OnDestroy {
  public isSidebarVisible = true;
  public adminMenuOpen = false;
  public masterDataMenuOpen = false;
  public transactionMenuOpen = false;
  public subscriptionMenuOpen = false;

  public loading = false;
  public userInfoModels: UserInfoDTO[] = [];
  public userInfoModels$: Observable<UserInfoDTO[]>;

  public homeRoute = homeRoute;
  public loginRoute = loginRoute;
  public userManagementRoute = userManagementRoute;
  public clientAdministrationRoute = clientAdministrationRoute;
  public categoryRoute = categoryRoute;
  public subscriptionRoute = subscriptionRoute;
  public privacypolicyRoute = privacypolicyRoute;
  public orderRoute = orderRoute;
  public deliveryRoute = DeliveryDetailsRoute;
  public productTemplateRoute = productTemplateRoute;
  public salesOverviewRoute = salesOverviewRoute;
  public invoiceRoute = invoiceRoute; 

  @ViewChild('menu') menu: any;
  @ViewChild('sidebarWrapper') sidebarWrapper: ElementRef;


  @Output() sidebarToggled = new EventEmitter<boolean>();

  public userIcon = 'icon-user';
  public userNavigation: MenuItem[] = [];
  private documentClickListener: Function;
  public versionLabel = 'Version: loading...';

  constructor(
    private router: Router,
    private modalService: ModalService,
    private translate: TranslateService,
    public authService: AuthService,
    private renderer: Renderer2,
    private versionService: VersionService,
  ) { }


  public ngOnInit(): void {
    this.setUserNavigationItems();
    this.loadVersion();

    this.translate.onLangChange.subscribe(() => {
      this.setUserNavigationItems();
    });


  }

  public ngOnDestroy(): void {
    if (this.documentClickListener) {
      this.documentClickListener();
    }
  }


  private setUserNavigationItems(): void {
    this.userNavigation = [
      {
        label: this.translate.instant('i18n.core.navigation.editProfile'),
        icon: 'icon-user--profile',
        command: () => this.editUser(),
      },
      {
        label: this.translate.instant('i18n.core.navigation.changePassword'),
        icon: 'icon-password',
        command: () => this.changePassord(),
      },
      {
        label: this.translate.instant('i18n.core.navigation.logout'),
        icon: 'icon-logout',
        command: () => this.logout(),
      },
      {
        label: this.versionLabel,
        disabled: true,
      },
    ];
  }

  private loadVersion(): void {
    console.log('URL from navigation component:', environment.apiServerUrl);
    this.versionService.getBackendVersion().subscribe({
      next: v => {
        this.versionLabel = `v${v.version} (Build ${v.build})`;
        this.setUserNavigationItems();
      },
      error: () => {
        this.versionLabel = 'Version unavailable';
        this.setUserNavigationItems();
      }
    });
  }

  public editUser(): void {
    this.router.navigate([editProfileRoute]);
  }

  public logout(): void {
    const dialog = this.modalService.showOkCancelDialog(
      'i18n.core.modal.logout.title',
      'i18n.core.modal.logout.question'
    );

    dialog.onOkSubject.subscribe(() => {
      this.router
        .navigate([loginRoute], { queryParams: { init: 'true' } })
        .then(() => {
          this.authService.logout();
        });
    });
  }

  public changePassord(): void {
    this.router.navigate([changePasswordRoute]);
  }


  public toggleAdminMenu(): void {
    this.adminMenuOpen = !this.adminMenuOpen;
  }

  public toggleMasterDataMenu(): void {
    this.masterDataMenuOpen = !this.masterDataMenuOpen;
  }

  public toggleTransactionDataMenu(): void {
    this.transactionMenuOpen = !this.transactionMenuOpen;
  }

  public toggleSubscriptionDataMenu(): void {
    this.subscriptionMenuOpen = !this.subscriptionMenuOpen;
  }

  public toggleSidebar(): void {
    this.isSidebarVisible = !this.isSidebarVisible;

    this.sidebarToggled.emit(this.isSidebarVisible);
  }

  public closeSidebar(): void {
    this.isSidebarVisible = false;
    this.sidebarToggled.emit(false);
  }

  public openSidebar(): void {
    this.isSidebarVisible = true;
    this.sidebarToggled.emit(true);
  }
}